import { Grid } from '@material-ui/core';
import React from 'react';
import { FormInput, HelpDocLink } from '../../../components';
import lightHouseArticles from '../../../configs/lightHouseArticles';


const UploadMediaFromUrlForm = () => {

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FormInput name="title" label="Media Title" autoFocus dontCheckEmptyValue={false} />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          name="url"
          label="URL"
          dontCheckEmptyValue={false}
          helpInfo={<span>The URL must point to a valid video file such as a .mp4 or .mov. <HelpDocLink id={lightHouseArticles.validVideo}>View Help</HelpDocLink></span>}
        />
      </Grid>
    </Grid>
  );
};

export default UploadMediaFromUrlForm;
